import { useState, useEffect } from 'react';
import { X, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import UpgradeRequestModal from './UpgradeRequestModal';

const RESOURCE_LABELS = {
    activeJobs: 'active jobs',
    interviews: 'interviews this month',
    users: 'team members',
    proctoring: 'proctoring',
};

export default function PlanLimitBanner() {
    const [limitDetail, setLimitDetail] = useState(null);
    const [upgradeOpen, setUpgradeOpen] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            setLimitDetail(e.detail);
        };
        window.addEventListener('echohire:plan-limit', handler);
        return () => window.removeEventListener('echohire:plan-limit', handler);
    }, []);

    if (!limitDetail) return null;

    const resourceLabel = RESOURCE_LABELS[limitDetail.resource] || limitDetail.resource;

    return (
        <>
            <div className="flex items-center gap-3 rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-2.5 mb-4">
                <TrendingUp className="h-4 w-4 shrink-0 text-destructive" />
                <p className="flex-1 text-sm font-medium text-destructive">
                    You&apos;ve reached your {resourceLabel} limit
                    {limitDetail.limit ? ` (${limitDetail.current}/${limitDetail.limit})` : ''}.
                    Upgrade your plan to continue.
                </p>
                <Button
                    size="sm"
                    variant="outline"
                    className="h-7 shrink-0 gap-1.5 border-destructive text-xs text-destructive hover:bg-destructive/10"
                    onClick={() => setUpgradeOpen(true)}
                >
                    Request Upgrade
                </Button>
                <button
                    type="button"
                    onClick={() => setLimitDetail(null)}
                    className="shrink-0 text-destructive opacity-70 hover:opacity-100"
                    aria-label="Dismiss"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
            <UpgradeRequestModal
                open={upgradeOpen}
                onClose={() => setUpgradeOpen(false)}
            />
        </>
    );
}
